<template>
  <div>
    <PageLoader :storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#427D2D" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color:#fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color:#fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <div class="full-screen-map-wrapper">
      <BaseLeafletMap
        title="Hospitals Map"
        :layers="mappedLayers"
        :statistics="mapStats"
        :loading="appLoading"
        :toolbar="{ search: true, fullscreen: true, fitBounds: true, satellite: true }"
        height="100vh"
        @marker-click="onMarkerClick"
            >
            </BaseLeafletMap>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import BaseLeafletMap from '@/components/maps/BaseLeafletMap.vue';
import HospitalPopup  from '@/components/maps/popups/HospitalPopup.vue';
import { layerFactory }  from '@/components/maps/utils/layerFactory';
import { LAYER_TYPES }   from '@/components/maps/constants/layerTypes';
import { STATUS_COLORS } from '@/components/maps/constants/statusColors';

export default {
  components: { BaseLeafletMap },

  data() {
    return {
      appLoading:       false,
      ServerError:      false,
      showSnackBar:     false,
      timeout:          5000,
      msg:              null,
      data:             [],
      keyword:          '',
      hospitalname:     '',
      totalcount:       0,
      hospitalnamedata: false,
      alldata:          true,
      districtdata:     false,
    };
  },

  computed: {
    districts() {
      return ['All', ...this.$store.state.districts];
    },

    hospitalsWithoutLocation() {
      if (!this.data || !this.data.length) return 0;
      return this.data.filter(h => !h.location || h.location.length !== 2).length;
    },

    hospitalsWithLocation() {
      return this.data.filter(h => h.location && h.location.length === 2).length;
    },

    mappedLayers() {
      return [
        layerFactory({
          id:         LAYER_TYPES.HOSPITALS,
          title:      'Hospitals',
          color:      STATUS_COLORS.HOSPITAL,
          clustered:  false,
          searchable: true,
          legend: [{ color: STATUS_COLORS.HOSPITAL, label: 'Hospital' }],
          markers: this.data
            .filter(h => h.location && h.location.length === 2)
            .map(h => ({
              id:           h._id,
              lat:          h.location[1],
              lng:          h.location[0],
              layer:        LAYER_TYPES.HOSPITALS,
              popup:        HospitalPopup,
              searchFields: [h.name, h.district, h.address].filter(Boolean),
              data:         h,
            })),
        }),
      ];
    },

    mapStats() {
      return [
        { title: 'Total Hospitals', value: this.totalcount,              icon: 'mdi-hospital-building', color: STATUS_COLORS.HOSPITAL  },
        { title: 'With Location',   value: this.hospitalsWithLocation,   icon: 'mdi-map-marker-check',  color: STATUS_COLORS.AVAILABLE },
        { title: 'Without GPS',     value: this.hospitalsWithoutLocation,icon: 'mdi-map-marker-off',    color: STATUS_COLORS.OFFLINE   },
      ];
    },
  },

  watch: {
    hospitalnamedata(val) {
      if (val) this.alldata = false;
      else this.checkAllSelected();
    },
    districtdata(val) {
      if (val) this.alldata = false;
      else this.checkAllSelected();
    },
  },

  beforeMount() {
    this.getData();
    this.$store.dispatch('fetchDistricts');
  },

  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method:  'GET',
        url:     '/hospital/all',
        headers: { 'x-auth-token': localStorage.getItem('token') },
      })
        .then(response => {
          if (response.data.status === true) {
            this.data       = response.data.data;
            this.totalcount = this.data.length;
          } else {
            this.msg = response.data.msg; this.showSnackBar = true;
          }
        })
        .catch(err => { this.ServerError = true; console.log(err); })
        .finally(() => { this.appLoading = false; });
    },

    searchhosp() {
      this.appLoading = true;
      axios({
        method:  'POST',
        url:     '/hospital/search',
        headers: { 'x-auth-token': localStorage.getItem('token') },
        data:    { name: this.hospitalname, district: this.keyword },
      })
        .then(response => {
          if (response.data.status === true) {
            this.data = response.data.data;
          } else {
            this.msg = response.data.msg; this.showSnackBar = true;
          }
        })
        .catch(err => { this.ServerError = true; console.log(err); })
        .finally(() => { this.appLoading = false; });
    },

    reset() {
      this.hospitalname = '';
      this.getData();
    },

    checkUpdate() {
      if (this.alldata) {
        this.hospitalnamedata = false;
        this.districtdata     = false;
        this.keyword          = '';
        this.hospitalname     = '';
        this.getData();
      }
    },

    checkAllSelected() {
      if (!this.hospitalnamedata && !this.districtdata) {
        this.alldata = true;
        this.getData();
      }
    },

    onMarkerClick({ data }) {
      console.log('Hospital clicked:', data.name);
    },

    formatDate(date) {
      if (!date) return '-';
      const [year, month, day] = date.slice(0, 10).split('-');
      return `${day}-${month}-${year}`;
    },
  },
};
</script>
<style scoped>
.full-screen-map-wrapper {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.floating-warning {
  position: absolute;
  top: 80px;
  left: 16px;
  z-index: 1200;
  max-width: 320px;
  pointer-events: auto;
}

.warning-content {
  display: flex;
  align-items: flex-start;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(12px);
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 8px 32px rgba(0,0,0,0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.warning-content:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 36px rgba(0,0,0,0.12);
}

.warning-text {
  font-family: 'Poppins', poppinsregular, sans-serif;
  font-size: 12.5px;
  color: #4b5563;
  line-height: 1.5;
}

.warning-text strong {
  color: #1f2937;
  font-weight: 700;
}
</style>

<style scoped>
.heading    { font-family: poppinsregular; font-size: 20px; font-weight: 900; }
.subheading { font-family: poppinsregular; font-size: 15px; font-weight: 500; }
</style>